angular.module("infoLicenzaNoleggio.components", [])
    .component("infoLicenzaNoleggio", {
        templateUrl: "ng/components/riscattoTermine/infoLicenzaNoleggio/infoLicenzaNoleggio.view.html",
        bindings: {
            richiestePostVendita: "=",
            validateComponent: '&'
        },
        controller: InfoLincenzaNoleggio,
        controllerAs: "infoLicenzaNoleggioCtrl"
    })

function InfoLincenzaNoleggio(
    $scope,
    $timeout
) {

    var self = this;

    self.$onInit = function () {
        self.validationObj = {
            documentDate: {
                disabledDays: [0],
                disabledDates: [
                    "01-01",
                    "06-01",
                    "25-04",
                    "01-05",
                    "02-06",
                    "15-08",
                    "01-11",
                    "08-12",
                    "25-12",
                    "26-12"
                ]
            }
        };

        $timeout(function () {
            checkValidation();
        }, 300)
    }

    self.getTodaysDate = function () {
        return moment().format("DD/MM/YYYY");
    };

    self.changeDate = function (type, value) {
        self.richiestePostVendita.metadata.riscattoATermine.dataAutNoleggio = value;
        checkValidation();

    }

    self.validate = function (value, name) {
        self.richiestePostVendita.metadata.riscattoATermine[name] = value;
        checkValidation();
    }

    var checkValidation = function () {
        console.log("info form", $scope.infoLicenzaForm.$valid)
        self.validateComponent({ value: $scope.infoLicenzaForm.$valid })
    }
}